import React from "react";
import { Instagram, Linkedin, Twitter, X } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
function TikTokIcon({
  className,
  ...props
}: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground py-16 border-t border-border/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
          {}
          <div className="space-y-6">
            <Link to="#" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582830/img/imperium_technologies_logo_footer_nobg.png" alt="Imperium Technologies" className="h-7 w-auto object-contain brightness-0 invert opacity-90" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">Imperium Technologies provides clients with access to a disciplined copytrading service built around algorithmic execution, structured risk logic, and professional onboarding.</p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold tracking-tight text-foreground/90 uppercase text-xs">Navigation</h3>
            <ul className="space-y-3">
              {[{
              label: "Home",
              href: "/"
            }, {
              label: "Backtest Results",
              href: "/live-results"
            }, {
              label: "About Us",
              href: "/about-us"
            }, {
              label: "Access",
              href: "/access"
            }, {
              label: "Dashboard",
              href: "/client-dashboard-2"
            }].map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold tracking-tight text-foreground/90 uppercase text-xs">Client Access</h3>
            <ul className="space-y-3">
              {[{
              label: "Register",
              href: "/access/?imp_tab=register"
            }, {
              label: "Login",
              href: "/access/?imp_tab=login"
            }, {
              label: "Onboarding",
              href: "/access"
            }, {
              label: "View Performance",
              href: "/live-results"
            }].map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold tracking-tight text-foreground/90 uppercase text-xs">Contact</h3>
            <p className="text-muted-foreground text-sm">
              For registration, onboarding, or client access questions, contact the Imperium Technologies team.
            </p>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-[12px] text-muted-foreground/60">
            <p>© {new Date().getFullYear()} Imperium Technologies. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="#" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-foreground transition-colors">
                Terms of Service
              </Link>
              <Link to="#" className="hover:text-foreground transition-colors hidden lg:block">
                Risk Disclosure
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {[{
            icon: TikTokIcon,
            label: "TikTok",
            href: "https://www.tiktok.com/@imperieumtechnologies?_r=1&_t=ZN-94evX0QmI7y"
          }, {
            icon: X,
            label: "X",
            href: "https://x.com/imperiumtechno?s=11&t=O2420bkJToWrZiIRw6seFg"
          }, {
            icon: Instagram,
            label: "Telegram",
            href: "https://www.instagram.com/imperium_technologies_?igsh=dW4yeHczMzdkMWy"
          }].map((social, i) => <Link key={i} data-index={i} to={social.href} className="p-2 rounded-full border border-border/40 text-muted-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300" aria-label={social.label}>
                <social.icon className="size-4" />
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}